import factory from '@atlassian/trello-error-ext';
// eslint-disable-next-line @trello/no-module-logic
export const AttachmentLimitExceededError = factory(
  'Attachment::LimitExceeded',
);
